<div
  class="page-content responsive-height topspaces"
  *ngrxLet="dashboardFacade.getDashboardData$ as dashboardData"
>
  <div class="container-fluid">
    <div
      class="dashboardtext"
      *ngrxLet="{
        profileData: (UserDetailsFacade.profileData$ | async),
        getOrganizationName: (UserDetailsFacade.getOrganizationName$ | async)
      } as data"
    >
      <ng-container>
        <p>Welcome to the</p>
        <p
          (next)="onNext()"
          joyrideStep="step1"
          stepPosition="bottom"
          text="Hi there! 
                      Let's get you started with creating your project.
                      If you're familiar with how to create a project, you can turn the guided tour feature off in the settings. 
                      If you get stuck, hover over different buttons to see what they do."
        >
          <span
            class="username-hide-mobile"
            *ngIf="!!$any(data.profileData)?.organizationName || !!data.getOrganizationName"
          >
            {{ $any(data.profileData)?.organizationName || data.getOrganizationName }} </span
          >dashboard
        </p>
      </ng-container>
    </div>
  </div>

  <div class="container-fluid pt-120">
    <div class="col-md-12">
      <div class="row">
        <div class="col-12 col-sm-12">
          <piqet-angular-projects [projectList]="dashboardData?.projectlist" [class]="'addScroll'">
          </piqet-angular-projects>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="divider"></div>
          <piqet-angular-global-environmental-savings
            [stepCount]="'step4'"
            [stepTitle]="'Scenarios completed'"
            [stepText]="'This is a log of your number of projects and scenarios.'"
            [environmentData]="dashboardData"
            (achivementsEvent)="updateAchievementsVisibility($event)"
          >
          </piqet-angular-global-environmental-savings>
        </div>
      </div>
    </div>
  </div>
  <div class="news-div">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <piqet-angular-news [newsList]="dashboardData?.newsList"></piqet-angular-news>
        </div>
      </div>
    </div>
  </div>
</div>
<ngx-spinner size="medium" color="#fff" [type]="typeSelected" [fullScreen]="true"> </ngx-spinner>
